import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/ekgImport.actions'
import * as crewActions from '../../crew/store/crew.actions'
import { IOptions, IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../../options/services/options.service'

const sortMonitorOptions = (entity: IOptions): void => {
  entity.sort((a, b) => {
    if (a.id === 0) {
      return -1
    } else if (b.id === 0) {
      return 1
    } else {
      return (a.name || '')?.localeCompare(b.name || '')
    }
  })
}

export function* setEkgMonitorOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getEkgMonitorOptions])
    const { entity } = response

    sortMonitorOptions(entity)
    const entityWithoutAllMonitors = entity.filter((option) => {
      return option.id !== 0
    })

    yield put(actions.setMonitorOptions(entity))
    yield put(crewActions.setPrimaryMonitorOptions(entityWithoutAllMonitors))
  } catch (e) {
    yield put(throwPcrException(`setEkgMonitorOptions() error: ${e}`))
  }
}
export function* setEkgMonitorOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setEkgMonitorOptions)
}
